import { Badge, Table } from "flowbite-react";
import { formatToReal } from "../../../utils/utils";

const Socios = ({ socios, isAdm = false }) => {
  return (
    <>
      <div className="overflow-x-hidden border-gray-300 border rounded-lg mt-3">
        <Table striped>
          <Table.Head className="text-black">
            <Table.HeadCell
              className="text-center py-2 px-1"
              style={{ background: "#EBF5FF" }}
            >
              Nº
            </Table.HeadCell>
            <Table.HeadCell className="py-2" style={{ background: "#EBF5FF" }}>
              Nome
            </Table.HeadCell>
            <Table.HeadCell
              className="text-center py-2 px-1"
              style={{ background: "#EBF5FF" }}
            >
              Função
            </Table.HeadCell>
            {!isAdm && (
              <Table.HeadCell
                className="text-center py-2 px-1"
                style={{ background: "#EBF5FF" }}
              >
                Part. (%)
              </Table.HeadCell>
            )}

            <Table.HeadCell
              className="text-center py-2 px-1"
              style={{ background: "#EBF5FF" }}
            >
              Tem restrição?
            </Table.HeadCell>
          </Table.Head>
          {socios?.length > 0 && (
            <Table.Body className="divide-y">
              {socios?.map((socio, index) => (
                <Table.Row
                  key={index}
                  className="bg-white dark:border-gray-700 dark:bg-gray-800 text-black"
                >
                  <Table.Cell className="font-medium dark:text-white text-center py-1 px-1">
                    {index + 1}
                  </Table.Cell>
                  <Table.Cell className=" py-1">
                    <div>{socio?.nome || "-"}</div>
                    <div style={{ fontSize: "10px" }}>CPF: {socio?.cpf}</div>
                  </Table.Cell>
                  <Table.Cell className="text-center py-1 px-1 px-1">
                    {socio?.cargo || "-"}
                  </Table.Cell>
                  {!isAdm && (
                    <Table.Cell className="text-center py-1 px-1 px-1">
                      {socio?.percentualParticipacao || "-"}
                    </Table.Cell>
                  )}

                  <Table.Cell className="text-center py-1 px-1 px-1">
                    {socio?.temRestricoes ? (
                      <span className="text-red-500 font-semibold">Sim</span>
                    ) : (
                      <span className="text-green-500 font-semibold">Não</span>
                    )}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          )}
        </Table>
      </div>
    </>
  );
};

export default Socios;
